import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-generics-filters',
  storeModule.createStoreModule('leads-receptions-generics-filters', {
    fetchFiltersURL: 'leads-receptions/dashboard/filters'
  })
)
